import styled from 'styled-components';
import { useWYSIWYGContext } from '../contexts/WYSIWYGContext';
import { useOnNewFileSelected } from '../hooks/useOnNewFileSelected';

const StyledInput = styled.input`
  display: none;
  height: 0;
  width: 0;
`;

export const DATA_TEST = {
  input: 'load-file-button-input-wysiwyg',
};

export const HiddenInput = () => {
  const { loadHtmlFileInputRef } = useWYSIWYGContext();
  const onNewFileSelected = useOnNewFileSelected();

  return (
    <StyledInput
      accept="text/plain, text/html"
      data-test={DATA_TEST.input}
      multiple={false}
      onChange={onNewFileSelected}
      ref={loadHtmlFileInputRef}
      type="file"
    />
  );
};
